import React from 'react';
import Header from "./components/Header";
import HeroSection from "./components/HeroSection";
import Behandlinger from "./components/Behandlinger";
import Priser from "./components/Priser";
import Testimonials from "./components/Testimonials";
import OmOss from "./components/OmOss";
import KontaktOss from "./components/KontaktOss";
import Footer from "./components/Footer";
import './App.css';


function App() {
  return (
    <div className="App">
      <Header />
        <HeroSection/>
        <Behandlinger/>
        <Priser/>
        <Testimonials/>
        <OmOss/>
        <KontaktOss/>
        <Footer/>
    </div>
  );
}

export default App;
